import { memo } from 'react';
import MuiDialog, { DialogProps } from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';
import { useStyles } from './style';

interface Props {
  handleClose?: () => void;
  fullHeight?: boolean;
  withCloseButton?: boolean;
  cls?: {
    childrenRoot?: string;
  };
}

const Dialog: React.FC<DialogProps & Props> = ({
  handleClose,
  withCloseButton = true,
  children,
  fullHeight = false,
  cls,
  ...rest
}) => {
  const classes = useStyles();

  const onClose = () => {
    if (handleClose) {
      handleClose();
    }
  };

  return (
    <MuiDialog
      {...rest}
      onClose={handleClose ? onClose : undefined}
      classes={{
        paperFullWidth: clsx(classes.fullWidth, {
          [classes.fullHeight]: fullHeight,
        }),
        paperWidthLg: classes.papperWidthLg,
      }}
      PaperProps={{
        classes: {
          rounded: classes.rounded,
        },
      }}
      BackdropProps={{
        classes: {
          root: classes.backdrop,
        },
      }}
    >
      <div
        className={clsx(
          classes.childrenRoot,
          {
            [classes.fullHeight]: fullHeight,
          },
          cls?.childrenRoot
        )}
      >
        {withCloseButton && handleClose ? (
          <Button
            className={classes.button}
            onClick={handleClose ? () => handleClose() : undefined}
          >
            <CloseIcon className={classes.closeIcon} />
          </Button>
        ) : null}
        {children}
      </div>
    </MuiDialog>
  );
};

export default memo(Dialog);
